import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';

@customElement('webs-header-card-item')
export class HeaderCardItem extends LitElement {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    css`
    .m-header-card-item {
      align-items: center;
      display: flex;
      margin-bottom: 0.7rem;
    }
    .m-header-card-item__text {
      margin: 0 0 0 0.7rem;

      font-family: var(--font-family-base);
      font-size: .8rem;
      line-height: 1.5;
      color: var(--color-dark-grey);
    }
    `
  ]

  @property({attribute: 'src'})
  imgSrc: string;

  @property({attribute: 'alt'})
  imgAlt: string;

  @property()
  text: string;

  protected render(): unknown {
    return html`
    <div class="m-header-card-item">
      <picture><img src="${this.imgSrc}" alt="${this.imgSrc}" loading="lazy" width="25"></picture>
      <p class="m-header-card-item__text">${this.text}</p>
    </div>
    `
  }
}
